import React, { useEffect, useMemo, useState } from "react";
import { render, unmountComponentAtNode } from "react-dom";
import { truncateString } from "../../helpers/string";
import Heart from "../heart";
import NewCartButton from "../cartbutton/NewCartButton";
import PreorderButton from "../PreorderButton";
import Preview from "../preview";
import ProductRating from "../productrating";
import ProductRatingStars from "../productrating/ratings-stars";
import AudioPreview from "../preview/AudioPreview";
import CountDown from "../CountDown";
import { BookHelper } from "../../helpers/book";

const dateFormatter = new Intl.DateTimeFormat("hu-HU", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
});

const POINT_DISCOUNT_TYPE_MULTIPLIER = 1;

function formatPrice(price) {
    if (!price) return "0 Ft";
    if (typeof price === "string") price = price.replace(/\s/g, "");
    return window.Dibook.language.formatCurrency(price);
}

function formatDate(date) {
    return date ? dateFormatter.format(new Date(date)) : '';
}

export default function NewBookCard(props) {
    // console.log(props);
    let ID = props.elem?.dataset?.id ? Number(props.elem.dataset.id) : props.bookid;
    let layout = props.elem?.dataset?.layout ? props.elem.dataset.layout : props.layout;
    let owned = props.elem?.dataset?.owned ? props.elem.dataset.owned : props.owned;
    let title = props.elem?.dataset?.title ? props.elem.dataset.title : props.title;
    let subtitle = props.elem?.dataset?.subtitle ? props.elem.dataset.subtitle : props.subtitle;
    let author = props.elem?.dataset?.author ? JSON.parse(props.elem.dataset.author) : props.author;
    let slug = props.elem?.dataset?.slug ? props.elem.dataset.slug : props.slug;
    let cover = props.elem?.dataset?.cover ? props.elem.dataset.cover : props.cover;
    let oldprice = props.elem?.dataset?.oldprice ? props.elem.dataset.oldprice : props["old_price"];
    let price = (props.elem?.dataset?.price ? props.elem.dataset.price : props.price) || 0;
    price = typeof price === "string" ? price.replace(/\s/g, "") : price;
    let preorderPrice = props.elem?.dataset?.preorder_discount_percentage
        ? props.elem.dataset.preorder_discount_percentage
        : props.preorder_discount_percentage;
    let discountType = props.elem?.dataset?.["discountType"]
        ? props.elem.dataset["discountType"]
        : props["discount_type"];
    let discountQuantityData = props.elem?.dataset?.["discountQuantity"]
        ? props.elem.dataset?.["discountQuantity"]
        : props["discount_quantity"];

    const discountQuantity = useMemo(() => BookHelper.getBookDiscount(discountType, price, oldprice, discountQuantityData), [discountType, price, oldprice, discountQuantityData]);

    let discountPostfix = props.elem?.dataset?.["discountPostfix"]
        ? props.elem.dataset["discountPostfix"]
        : props["discount_postfix"];
    let discountBackground = props.elem?.dataset?.["discountBackground"]
        ? props.elem.dataset["discountBackground"]
        : props["discount_background"];
    let countDown = props.elem?.dataset?.["countdown"] ?? props.discount_end ?? props.discount?.end ?? 0;
    
    let titleClass = "";

    let pointDiscountType = props.elem?.dataset?.["pointDiscountType"]
        ? props.elem.dataset["pointDiscountType"]
        : props["point_discount_type"];
    pointDiscountType = pointDiscountType ? parseInt(pointDiscountType) : pointDiscountType;

    let pointDiscountQuantity = props.elem?.dataset?.["pointDiscountQuantity"]
        ? props.elem.dataset?.["pointDiscountQuantity"]
        : props["point_discount_quantity"];
    let comingSoon = props.elem?.dataset?.["comingsoon"]
        ? props.elem.dataset?.["comingsoon"]
        : props["comingsoon"];

    let categoryName = props.elem?.dataset?.["categoryname"]
        ? props.elem.dataset?.["categoryname"]
        : props["category_name"];

    if(categoryName == null)
        categoryName = props.maincategory?.name ?? null;

    let categoryHref = props.elem?.dataset?.["categoryhref"]
        ? props.elem.dataset?.["categoryhref"]
        : props["category_href"];

    let releaseDate = props.elem?.dataset?.["releasedate"]
        ? props.elem?.dataset?.["releasedate"]
        : props["release_date"];


    comingSoon = comingSoon ?? "false";
    comingSoon = comingSoon !== "false";
    const [rating, setRating] = useState();

    let loggedin = props.elem?.dataset?.loggedin.length
        ? props.elem.dataset.loggedin !== "false"
        : props.loggedin;

    let top3 = props.elem?.dataset?.top3 ? props.elem.dataset.top3 !== "false" : props.top3;

    // Default layout
    layout = layout ? layout : "table";

    const type = Number(props.elem?.dataset?.type ? props.elem.dataset.type : props.type);
    let bookType;
    if (type === 1) {
        titleClass = "title-icon ebook";
        bookType = "ebook";
    } else if (type === 2) {
        titleClass = "title-icon audio";
        bookType = "audio";
    } else if (type === 3) {
        bookType = "giftcard";
    }

    let tags = props.elem?.dataset?.tag ? props.elem.dataset.tag : props.tag;
    tags = tags ? tags : discountType ? ["Akció"] : [];
    
    if(typeof tags == "string")
        tags = [tags];
    
    tags.forEach((tag, i) => {
        if(typeof tag == "object") return;

        tag = {value: tag, style: { backgroundColor: "#9E89E6" }};
        if (tag.value?.toLowerCase() === "hamarosan" || tag.value?.toLowerCase() === "előjegyezhető") tag.style = { backgroundColor: "#FACC14", color: 'black' };
        else if (tag.value?.toLowerCase() === "bestseller") tag.style = { backgroundColor: "#3772FF" };
        else if (tag.value?.toLowerCase() === "akció" || tag.value?.toLowerCase() === "villámakció!") tag.style = { backgroundColor: "#ff0173" };

        tags[i] = tag;
    });

    const topkey = props.elem?.dataset?.topkey ? props.elem.dataset.topkey : props.topkey;
    const noRating = props.elem?.dataset?.norating
        ? props.elem.dataset.norating === "true"
        : props.noRating;

    const PERCENTAGE_DISCOUNT = 1;
    const FIX_FT_DISCOUNT = 2;
    const points =
        Number(pointDiscountType) === PERCENTAGE_DISCOUNT
            ? Math.round(pointDiscountQuantity * (price * 0.05))
            : Number(pointDiscountType) === FIX_FT_DISCOUNT
            ? pointDiscountQuantity
            : Math.round(price * 0.05);

    const userLevel = window.Dibook.userLevel ?? 0;    
    const newPoints = useMemo(() => {
        const isPriceCapped = BookHelper.getIsPriceCapped(releaseDate, type);
        let calculatedPoints;

        switch (userLevel) {
            case 2:
                calculatedPoints = Math.round(price * 0.075);
                break;
            case 3:
                calculatedPoints = Math.round(price * 0.10);
                break;
            case 4:
                if(isPriceCapped)
                    calculatedPoints = Math.round(price * 0.10);
                else
                    calculatedPoints = Math.round(price * 0.15);

                break;
        
            default:
                calculatedPoints = points;
                break;
        }

        return calculatedPoints;
    }, [userLevel, points]);

    const noWishlist = props.noWishlist;

    function showPreview() {
        let elem = document.querySelector("#welcome-book-preview");
        if (!elem) {
            // create the preview div
            elem = document.createElement("div");
            elem.id = "welcome-book-preview";
            document.body.appendChild(elem);
        }
        if (bookType === "ebook")
            render(
                <Preview owned={owned} upcoming={comingSoon} bookId={ID} onClose={closePreview} />,
                elem
            );
        else render(<AudioPreview bookId={ID} onClose={closePreview} />, elem);
    }

    function closePreview() {
        const elem = document.querySelector("#welcome-book-preview");
        if (!elem) return;
        unmountComponentAtNode(elem);
    }

    useEffect(() => {
        $('[data-toggle="tooltip"]').tooltip();

        let rating = props.elem?.dataset?.rating ? Number(props.elem.dataset.rating) : props.rating;
        if (
            (rating === undefined || isNaN(rating)) &&
            props.ratings &&
            props.ratings.rateamount > 0
        )
            rating = props.ratings.average;
        updateRating(rating);

    }, []);

    function updateRating(average) {
        setRating(Math.round(average * 10) / 10);
    }

    function openModal() {
        closeModal();

        const ratingContainer = document.getElementById("book-rating-modal");
        if (!ratingContainer) return;
        ratingContainer.dataset.rating = rating ?? 0;
        ratingContainer.dataset.ratingamount = rating ?? 0;
        ratingContainer.dataset.bookid = ID;
        ratingContainer.dataset.login = loggedin;
        ratingContainer.dataset.onlyrating = "true";
        // console.log(ratingContainer.dataset);

        render(
            <ProductRating
                onClose={closeModal}
                onRated={updateRating}
                {...ratingContainer.dataset}
            />,
            ratingContainer
        );
        showRatingModal();
    }

    function showRatingModal() {
        const ratingModal = document.getElementById("ratingModal");
        const overlay = document.getElementById("overlay");
        ratingModal.classList.remove("hidden");
        overlay.classList.remove("hidden");
    }

    function closeModal() {
        const elem = document.getElementById("book-rating-modal");
        if (elem) unmountComponentAtNode(elem);
    }

    function isGiftCard() {
        return bookType === "giftcard";
    }

    return (
        <>
            <div className="h-100" style={{ position: "relative" }}>
                {!comingSoon && (
                    <div
                        className="widget-preview"
                        data-owned={owned}
                        data-upcoming={comingSoon}
                        data-id={ID}
                    />
                )}
                {!comingSoon && discountType && (
                    <div
                        className={
                            "image__label" + (discountType ? ` image__label--${discountType}` : "") + (tags.length > 1 ? ' image__label__lower' : '') + (' '+discountBackground)
                        }
                    >
                        <div className="image__label__text">
                            {discountQuantity}
                            <span className="image__label__postfix">{discountPostfix}</span>
                        </div>
                    </div>
                )}
                {!comingSoon && pointDiscountType && (
                    <div
                        className={
                            "image__label" +
                            (pointDiscountType
                                ? ` image__label--4`
                                : "")
                        }
                    >
                        <div
                            className={`image__label__text ${
                                pointDiscountType === POINT_DISCOUNT_TYPE_MULTIPLIER
                                    ? "text-center"
                                    : "image__label__postfix"
                            }`}
                        >
                            {pointDiscountQuantity}
                            {pointDiscountType === POINT_DISCOUNT_TYPE_MULTIPLIER && (
                                <>
                                    {"x"}
                                </>
                            )}
                            <br />
                            <span className="image__label__postfix">pont</span>
                        </div>
                    </div>
                )}
                <div
                    className={
                        (props.elem ? "" : "widget-bookcard") +
                        (owned ? " widget-bookcard--owned" : "") +
                        (layout ? ` widget-bookcard--${layout} h-100 d-flex flex-column` : "")
                    }
                >
                    <div
                        className="image bookcard-xmas-image new-book-card-background"
                        style={{
                            minHeight: isGiftCard() ? 140 : 350,
                            maxHeight: isGiftCard() ? 140 : 350,
                        }}
                    >
                        <a
                            href={bookType !== "giftcard" && slug}
                            className="position-relative w-100"
                        >
                            <div className="bookcard-tag-wrapper">
                                {tags.map(tag => 
                                    <p className="bookcard-tag" key={tag.value} style={tag.style}>
                                        {tag.value}
                                    </p>
                                )}
                            </div>
                            {countDown > 0 && 
                                <CountDown initialCountDown={countDown} />}
                            {!!topkey && (
                                <div className="list-item__badge">
                                    <div className="list-item__badge-count">{topkey}</div>
                                    <img
                                        loading="lazy"
                                        src="/images/bookmark-toplista.svg"
                                        alt="item-badge"
                                    />
                                </div>
                            )}
                            <img
                                className="bookcard-cover-8764923"
                                src={
                                    isGiftCard()
                                        ? `/images/voucher/${
                                              (title.includes('Egyedi') ? 'egyedi' : oldprice || price)
                                          }-voucher-sep-2025.webp`
                                        : cover
                                }
                                alt={title}
                                style={
                                    isGiftCard()
                                        ? { objectFit: "cover", width: "100%", borderRadius: 16 }
                                        : undefined
                                }
                                loading="lazy"
                            />
                        </a>
                    </div>
                    <div
                        className="meta-action new-book-card-background d-flex flex-column"
                        style={{ flex: 1 }}
                    >
                        <div className="meta" style={{ flex: 1 }}>
                            <div className="meta__title">
                                <div
                                    className="d-flex align-items-center justify-content-between"
                                    style={{ gap: 5 }}
                                >
                                    {categoryName && layout === "table" ? (
                                        <a className="category" href={categoryHref}>
                                            {categoryName}
                                        </a>
                                    ) : (
                                        <div style={{ height: 25 }} />
                                    )}
                                    {props.withDelete && (
                                        <button
                                            className="bg-transparent p-0 m-0 border-0 outline-0"
                                            style={{ cursor: "pointer" }}
                                            onClick={props.onDelete}
                                        >
                                            <img src="/images/icon/new-trash-icon.svg" alt="trash-icon" />
                                        </button>
                                    )}
                                    {!comingSoon && !noWishlist && <Heart id={ID} wishlist />}
                                </div>
                                <div className="title-with-icon d-flex justify-content-between mb-1">
                                    <a
                                        href={slug}
                                        title={title}
                                        className="book-title"
                                        style={{ height: 38 }}
                                    >
                                        {title}
                                    </a>
                                    {!comingSoon && (
                                        <span
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            title={
                                                bookType === "ebook" ? "Beleolvasó" : "Belehallgató"
                                            }
                                            className={titleClass}
                                            style={{ cursor: "pointer" }}
                                            onClick={showPreview}
                                        />
                                    )}
                                </div>
                            </div>

                            {layout === "list" && subtitle && (
                                <div className="meta__subtitle">
                                    <a href={slug}>{subtitle}</a>
                                </div>
                            )}
                            <div className="meta__author d-flex">
                                {author ? (
                                    Array.isArray(author) && author.length > 0 ? (
                                        <a href={author[0] && author[0].url}>
                                            {author[0] && author[0].name}
                                        </a>
                                    ) : (
                                        <a href={author.url}>{author.name}</a>
                                    )
                                ) : null}
                            </div>
                            {layout === "list" && (
                                <div className="meta__lead">{truncateString(props.lead, 150)}</div>
                            )}
                            <div className="new-bookcard-rating-container mt-1">
                                {(comingSoon && releaseDate) ? (
                                    <p className="new-bookcard-rating m-0 pt-1">
                                        Kb. {formatDate(releaseDate)}
                                    </p>
                                ) : noRating ? (
                                    <div></div>
                                ) : rating ? (
                                    <div
                                        className="new-bookcard-rating cursor-pointer"
                                        role="button"
                                        onClick={openModal}
                                    >
                                        <p className="m-0 pt-1">{rating}</p>
                                        <div>
                                            <ProductRatingStars
                                                size={20}
                                                rating={rating}
                                                src="/images/icon/new-star-{value}.svg"
                                            />
                                        </div>
                                    </div>
                                ) : (
                                    <p
                                        className="rating-placeholder cursor-pointer"
                                        role="button"
                                        onClick={openModal}
                                    >
                                        <span>Értékeld elsőként</span>
                                        <img src="/images/icon/blue-star.svg" alt="star-icon" />
                                    </p>
                                )}
                                <div className="d-flex flex-column align-items-end">
                                    {!comingSoon && !!oldprice && price != oldprice && (
                                        <del className="oldprice">{formatPrice(oldprice)}</del>
                                    )}
                                    {!comingSoon && (
                                        <p
                                            className="new-bookcard-rating m-0 pt-1"
                                            style={{ fontSize: 14 }}
                                        >
                                            {formatPrice(price)}
                                        </p>
                                    )}
                                    {comingSoon && preorderPrice && (
                                       <p
                                           className="new-bookcard-rating m-0 pt-1"
                                           style={{ fontSize: '1rem' }}
                                       >
                                           -{preorderPrice > 0 ? preorderPrice : ""} %
                                       </p>
                                    )}
                                    {!comingSoon && !discountType && points > 0 && [1,2].includes(type) && userLevel != 1 && (
                                        <p
                                            className={`m-0 font-weight-normal ${(userLevel > 1 ? 'old-points' : '')}`}
                                        >
                                            <span>{points} </span>
                                            <span>pont</span>
                                        </p>
                                    )}
                                    {!comingSoon && !discountType && points > 0 && userLevel > 0 && [1,2].includes(type) && (
                                        <p
                                            className="m-0 font-weight-normal text-nowrap"
                                            style={{ fontSize: 12 }}
                                        >
                                            <img 
                                                className="points-icon"
                                                src={
                                                    userLevel === 1
                                                    ? "/images/icon/customer-discount/bronz-dibook.svg"
                                                    : userLevel === 2
                                                    ? "/images/icon/customer-discount/ezust-dibook.svg"
                                                    : userLevel === 3
                                                    ? "/images/icon/customer-discount/arany-dibook.svg"
                                                    : userLevel === 4
                                                    ? "/images/icon/customer-discount/platina-dibook.svg"
                                                    : "/images/icon/customer-discount/nincs-dibook.svg"
                                                }
                                                alt="customer-retention-level" 
                                            />
                                            <span>{newPoints} </span>
                                            <span>pont</span>
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                        {!comingSoon && (
                            <div className="actions d-flex justify-content-center mt-2">
                                <NewCartButton
                                    altIcon
                                    id={ID}
                                    layout={layout === "list" ? "full" : "compact"}
                                    bookType={bookType}
                                    owned={owned}
                                    oldprice={oldprice}
                                    price={price}
                                    discountType={discountType}
                                    pointDiscountQuantity={pointDiscountQuantity}
                                    pointDiscountType={pointDiscountType}
                                />
                            </div>
                        )}
                        {comingSoon && !!price && !!preorderPrice && (
                            <div className="actions d-flex justify-content-center">
                                <PreorderButton
                                    id={ID}
                                    layout={layout === "list" ? "full" : "compact"}
                                    bookType={bookType}
                                    owned={owned}
                                    oldprice={oldprice}
                                    price={price}
                                    loggedIn={loggedin}
                                    discountType={discountType}
                                    pointDiscountQuantity={pointDiscountQuantity}
                                    pointDiscountType={pointDiscountType}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}
